// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uxp-button-wd.icon-only .uxp-button.has-icon{padding:12px;padding:1em}.uxp-button-wd.icon-only .uxp-button.has-icon.center .icon-placeholder,.uxp-button-wd.icon-only .uxp-button.has-icon.left .icon-placeholder,.uxp-button-wd.icon-only .uxp-button.has-icon.right .icon-placeholder{position:static;transform:unset;width:1em;height:1em}", ""]);
// Exports
module.exports = exports;
